module.exports = {"home":"Inicio"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/es/translations.json
// module id = 3842
// module chunks = 168707334958949